import * as React from 'react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0AvatarIcon, F0Button } from '@factorialco/f0-react'
import { AcademicCap } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import { useMarketplaceModulesPath } from 'modules/marketplace_modules/hooks/useMarketplaceModulesPath'
import { isValidModule } from 'modules/marketplace_modules/lib/typesValidation'
import CheckoutModal from 'modules/upsell/components/SelfUpsell/CheckoutModal'

type TextColor = React.ComponentProps<typeof Text.Normal>['color']

interface BannerConfig {
  bgStyle: {
    background: string
    borderBottom: string
    padding: string
    gap: string
  }
  textColor: TextColor
  title: string
  subtitle: string
  buttonBg?: string
}

const TrainingsBanner = ({
  chargebeeModuleName,
  moduleName,
  moduleSlug,
}: {
  chargebeeModuleName: string
  moduleName?: string
  moduleSlug: string
}) => {
  const [isCheckoutModalOpen, setIsCheckoutModalOpen] = useState(false)
  const navigate = useNavigate()
  const { getDetailPath } = useMarketplaceModulesPath()
  const defaultTexts: BannerConfig = {
    bgStyle: {
      background: '#051F510A',
      borderBottom: '1px solid #f1f1f1',
      padding: '12px 18px',
      gap: '10px',
    },
    textColor: 'grey1000',
    title: i18n.t('marketplace.revamp.trainings_banner.title'),
    subtitle: i18n.t('marketplace.revamp.trainings_banner.description', {
      module: moduleName,
    }),
  }

  return (
    <>
      <div className="py-2 px-4">
        <Box
          flexDirection="row"
          justifyContent="spaceBetween"
          flexWrap="wrap"
          gap="s8"
          style={defaultTexts.bgStyle}
        >
          <Box flexDirection="row" gap="s8" alignItems="center">
            <Box width="s40" height="s40">
              <F0AvatarIcon icon={AcademicCap} size="md" />
            </Box>
            <Box flexDirection="column" gap="s2">
              <Text.Normal weight="medium" color={defaultTexts.textColor}>
                {defaultTexts.title}
              </Text.Normal>
              <Text.Normal size="200" color={defaultTexts.textColor}>
                {defaultTexts.subtitle}
              </Text.Normal>
            </Box>
          </Box>
          <Box flexDirection="row" gap="s8" alignItems="center">
            <Box
              style={{
                color: defaultTexts.buttonBg || '',
              }}
            >
              <F0Button
                variant="primary"
                size="md"
                onClick={() => {
                  navigate(getDetailPath('lms'))
                }}
                label={i18n.t('marketplace.revamp.trainings_banner.discover_button')}
              />
            </Box>
            <Box
              style={{
                background: 'white',
                borderRadius: '10px',
              }}
            >
              <F0Button
                variant="outline"
                size="md"
                onClick={() => {
                  setIsCheckoutModalOpen(true)
                }}
                label={i18n.t('marketplace.revamp.trainings_banner.button')}
              />
            </Box>
          </Box>
        </Box>
      </div>

      {isValidModule(chargebeeModuleName) && chargebeeModuleName && (
        <CheckoutModal
          isOpen={isCheckoutModalOpen}
          onClose={() => setIsCheckoutModalOpen(false)}
          moduleName={chargebeeModuleName}
          moduleSlug={moduleSlug}
          from={'trainings_banner'}
        />
      )}
    </>
  )
}

export default TrainingsBanner
